import React, { useState, useEffect } from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import { Collapse, theme, Form, Input, Button } from 'antd';
import type { CSSProperties } from 'react';
import type { CollapseProps } from 'antd';

// Example JSON format for dynamic items
const dynamicData = [
    {
        key: '1',
        label: [
            { position: 'left', text: 'Left Position' },
            { position: 'center', text: 'Center Position' },
            { position: 'right', text: 'Right Position' },
        ],
        content: 'form', // A special identifier for form-related content
    },
    {
        key: '2',
        label: [
            { position: 'left', text: 'Left Position' },
            { position: 'center', text: 'Center Position' },
            { position: 'right', text: 'Right Position' },
        ],
        content: 'Cats are often known for their independence and agility.',
    },
    {
        key: '3',
        label: [
            { position: 'left', text: 'Left Position' },
            { position: 'center', text: 'Center Position' },
            { position: 'right', text: 'Right Position' },
        ],
        content: 'Birds are a diverse group of animals.',
    },
];

const CollapseAccordion: React.FC = () => {
    const { token } = theme.useToken();
    const [items, setItems] = useState<CollapseProps['items']>([]);

    // Form submit handler
    const handleFormSubmit = (values: any) => {
        console.log('Form values:', values);
    };

    // Fetch dynamic data and populate items
    useEffect(() => {
        const panelStyle: CSSProperties = {
            marginBottom: 24,
            background: token.colorFillContent,
            borderRadius: token.borderRadiusLG,
            border: 'none',
        };

        const formattedItems = dynamicData.map(item => {
            const labelContent = (
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    {item.label.map((labelItem, index) => (
                        <span
                            key={crypto.randomUUID()}
                            style={{
                                textAlign: labelItem.position as 'left' | 'center' | 'right', // Explicit type cast
                                flex: 1
                            }}
                        >
                            {labelItem.text}
                        </span>
                    ))}
                </div>
            );

            // Conditional content rendering
            let content = null;
            if (item.content === 'form') {
                content = (
                    <Form onFinish={handleFormSubmit} layout="vertical">
                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[{ required: true, message: 'Please enter your name!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[{ required: true, message: 'Please enter your email!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Bio"
                            name="bio"
                            rules={[{ required: true, message: 'Please enter your bio!' }]}
                        >
                            <Input.TextArea />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                );
            } else {
                content = <p>{item.content}</p>;
            }

            return {
                key: item.key,
                label: labelContent,
                children: content,
                style: panelStyle,
            };
        });
        setItems(formattedItems);
    }, [token]);

    return (
        <Collapse size="small"
            bordered={false}
            //defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}// NOSONAR : ignore
            style={{ background: token.colorBgContainer }}
            items={items}
        />
    );
};

export default CollapseAccordion;
